














import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import Vue from "vue";
import Component from "vue-class-component";
import { LocalStorage } from "../core/localStorage";
import { DateHelper } from "../core/helpers/dateHelper";

import CzPage from "../components/cz/CzPage.vue";
import CzCard from "../components/cz/CzCard.vue";
import CzChip from "../components/cz/CzChip.vue";
import CzLink from "../components/cz/CzLink.vue";
import CzNotice from "../components/cz/CzNotice.vue";
import CzPlanRow from "../components/cz/CzPlanRow.vue";
@Component({
  components: { CzPage, CzCard, CzChip, CzLink, CzNotice, CzPlanRow },
})
export default class MySurveysPage extends Vue {
  items: any[] = [];
  errorMsg: string = "";
  loaded: boolean = false;

  async mounted() {
    let cid = 0;
    try {
      cid = JSON.parse(LocalStorage.getWithTimeout("cc")).id;
    } catch {
      console.error("not customer logged found");
    }

    await this.loadData(cid);
  }

  async loadData(customerId: number) {
    let url = `${Settings.HostName}/api/publiccustomersurveys/customer-surveys/${customerId}`;
    let data = await new CrudService().httpGet(url);
    if (data == null) {
      this.errorMsg = this.$t("Crash").toString();
      console.error("Crash getting my surveys");
      return;
    }

    this.items = data;
    this.loaded = true;
  }

  isOpenable(item: any): boolean {
    return item.answeredDate !== null || item.token !== null;
  }

  isExpired(item: any): boolean {
    return item.answeredDate === null && item.expired === true;
  }

  statusText(item: any): string {
    if (item.answeredDate !== null) {
      const score = item.score === null ? "" : " · " + item.score + " / 100";
      return this.$t("Answered on").toString() + " " + DateHelper.toCultureString(item.answeredDate) + score;
    }
    if (item.expired === true) {
      return this.$t("Expired").toString();
    }
    return this.$t("Pending").toString();
  }

  open(item: any) {
    if (item.answeredDate !== null) {
      this.$router.push(`/customer-surveys/${item.id}`);
      return;
    }
    if (item.token !== null) {
      this.$router.push(`/survey/${item.token}`);
    }
  }
}
